import { OverlayContainer } from '@angular/cdk/overlay';
import { inject, Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class MdwMenuService {
  private overlayContainer = inject(OverlayContainer);

  public hasOpenMenu(whitelistSelector?: string) {
    const overlayContainerElement = this.overlayContainer.getContainerElement();
    const hasMenu = !!overlayContainerElement.querySelector('menu');

    if (!hasMenu) {
      return false;
    }

    if (whitelistSelector) {
      const whitelistedElement = overlayContainerElement.querySelector(whitelistSelector);

      return !whitelistedElement;
    }

    // If no whitelist selector is provided, return true if any menu is open
    return true;
  }
}
